import { authHeader, BASE_URL, handleResponse } from '@helpers/api';

const TEMPLATES_URL = `${BASE_URL}api/messaging/campaign-templates`;

function getTemplates(search = '', includeArchived = false) {
    const params = new URLSearchParams();
    if (search) params.set('search', search);
    if (includeArchived) params.set('includeArchived', 'true');
    const query = params.toString();

    return fetch(`${TEMPLATES_URL}${query ? `?${query}` : ''}`, {
        method: 'GET',
        headers: authHeader(),
    }).then(handleResponse);
}

function getEmailTemplate(id) {
    return fetch(`${TEMPLATES_URL}/email/${id}`, {
        method: 'GET',
        headers: authHeader(),
    }).then(handleResponse);
}

function createEmailTemplate(model) {
    return fetch(`${TEMPLATES_URL}/email`, {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(model),
    }).then(handleResponse);
}

function updateEmailTemplate(id, model) {
    return fetch(`${TEMPLATES_URL}/email/${id}`, {
        method: 'PUT',
        headers: authHeader(),
        body: JSON.stringify(model),
    }).then(handleResponse);
}

function deleteEmailTemplate(id) {
    return fetch(`${TEMPLATES_URL}/email/${id}`, {
        method: 'DELETE',
        headers: authHeader(),
    }).then(handleResponse);
}

function duplicateEmailTemplate(id) {
    return fetch(`${TEMPLATES_URL}/email/${id}/duplicate`, {
        method: 'POST',
        headers: authHeader(),
    }).then(handleResponse);
}

function archiveEmailTemplate(id) {
    return fetch(`${TEMPLATES_URL}/email/${id}/archive`, {
        method: 'POST',
        headers: authHeader(),
    }).then(handleResponse);
}

function unarchiveEmailTemplate(id) {
    return fetch(`${TEMPLATES_URL}/email/${id}/unarchive`, {
        method: 'POST',
        headers: authHeader(),
    }).then(handleResponse);
}

function renderEmailTemplate(id) {
    return fetch(`${TEMPLATES_URL}/email/${id}/render`, {
        method: 'POST',
        headers: authHeader(),
    }).then(handleResponse);
}

function renderEmailTemplateDraft(model) {
    return fetch(`${TEMPLATES_URL}/email/render`, {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(model),
    }).then(handleResponse);
}

function testSendEmailTemplate(id, model) {
    return fetch(`${TEMPLATES_URL}/email/${id}/test-send`, {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(model),
    }).then(handleResponse);
}

function getWhatsAppTemplate(id) {
    return fetch(`${TEMPLATES_URL}/whatsapp/${id}`, {
        method: 'GET',
        headers: authHeader(),
    }).then(handleResponse);
}

function createWhatsAppTemplate(model) {
    return fetch(`${TEMPLATES_URL}/whatsapp`, {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(model),
    }).then(handleResponse);
}

function updateWhatsAppTemplate(id, model) {
    return fetch(`${TEMPLATES_URL}/whatsapp/${id}`, {
        method: 'PUT',
        headers: authHeader(),
        body: JSON.stringify(model),
    }).then(handleResponse);
}

function deleteWhatsAppTemplate(id) {
    return fetch(`${TEMPLATES_URL}/whatsapp/${id}`, {
        method: 'DELETE',
        headers: authHeader(),
    }).then(handleResponse);
}

function submitWhatsAppTemplate(id) {
    return fetch(`${TEMPLATES_URL}/whatsapp/${id}/submit`, {
        method: 'POST',
        headers: authHeader(),
    }).then(handleResponse);
}

function updateWhatsAppTemplateMappings(id, model) {
    return fetch(`${TEMPLATES_URL}/whatsapp/${id}/mappings`, {
        method: 'PUT',
        headers: authHeader(),
        body: JSON.stringify(model),
    }).then(handleResponse);
}

function duplicateWhatsAppTemplate(id) {
    return fetch(`${TEMPLATES_URL}/whatsapp/${id}/duplicate`, {
        method: 'POST',
        headers: authHeader(),
    }).then(handleResponse);
}

function archiveWhatsAppTemplate(id) {
    return fetch(`${TEMPLATES_URL}/whatsapp/${id}/archive`, {
        method: 'POST',
        headers: authHeader(),
    }).then(handleResponse);
}

function unarchiveWhatsAppTemplate(id) {
    return fetch(`${TEMPLATES_URL}/whatsapp/${id}/unarchive`, {
        method: 'POST',
        headers: authHeader(),
    }).then(handleResponse);
}

function syncWhatsAppTemplates() {
    return fetch(`${TEMPLATES_URL}/whatsapp/sync`, {
        method: 'POST',
        headers: authHeader(),
    }).then(handleResponse);
}

export const campaignTemplatesService = {
    getTemplates,
    getEmailTemplate,
    createEmailTemplate,
    updateEmailTemplate,
    deleteEmailTemplate,
    duplicateEmailTemplate,
    archiveEmailTemplate,
    unarchiveEmailTemplate,
    renderEmailTemplate,
    renderEmailTemplateDraft,
    testSendEmailTemplate,
    getWhatsAppTemplate,
    createWhatsAppTemplate,
    updateWhatsAppTemplate,
    deleteWhatsAppTemplate,
    submitWhatsAppTemplate,
    updateWhatsAppTemplateMappings,
    duplicateWhatsAppTemplate,
    archiveWhatsAppTemplate,
    unarchiveWhatsAppTemplate,
    syncWhatsAppTemplates,
};
